import React from 'react';
import { useRegistrSVDetailContext } from '@gov-nx/module/page';
import { DataTable } from '@gov-nx/ui/web';

export const TableOtherRecords = () => {
	const { otherRecords } = useRegistrSVDetailContext();

	return (
		<DataTable responsive>
			<tbody>
				{otherRecords?.map((zaznam, i) => (
					<tr key={zaznam}>
						<td>{`${i + 1}. ${zaznam}`}</td>
					</tr>
				))}
			</tbody>
		</DataTable>
	);
};
